import configureStore from './storeConfiguration';
import { Thunk_Application } from "./thunk/Thunk_Application";
import { Thunk_Configuration } from "./thunk/Thunk_Configuration";
import { Thunk_Settings } from "./thunk/Thunk_Settings";
import { Thunk_Location } from "./thunk/Thunk_Location";

const store = configureStore();

export const applicationThunk = new Thunk_Application(store);
export const configurationThunk = new Thunk_Configuration(store);
export const settingsThunk = new Thunk_Settings(store);
export const locationThunk = new Thunk_Location(store);

window.store = store;

export default store;
